<template>
  <div id="cheque">
    <loading v-if="loadingRender"></loading>
    <panel Title="چک های واگذاری شده" Des="از طریق این فرم می توانید چک های واگذاری شده خود را مشاهده نمایید"
      :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <div class="row">
      <div class="card p-3 m-3 w-100" id="Date">
        <!-- <div class="row">
                <div class="co-md-3 col-12">
                    <i class="fa fa-reply Pointer border border-warning rounded-circle p-1" title="بازگشت صفحه قبل" @click="$router.go(-1)"></i>
                </div>
            </div> -->
        <div class="row">
          <span class="alert alert-dark w-100 p-2 m-2 text-center">لطفا پارامترهای خود را انتخاب کرده و سپس گزینه
            <span class="text-success">جستجو</span> را بزنید
          </span>
        </div>
        <div class="row">
          <div class="col-md-2 col-12 mt-2 text-right">
            <small>تاریخ چک از </small>
            <date-picker :editable="true" :auto-submit="true" :max="TarikhTa" color="rgb(94 163 30)" v-model="TarikhAz">
            </date-picker>
            <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr" />
          </div>
          <div class="col-md-2 col-12 mt-2 text-right">
            <small>تاریخ چک تا</small>
            <date-picker :editable="true" :auto-submit="true" :min="TarikhAz" color="rgb(94 163 30)" v-model="TarikhTa">
            </date-picker>
            <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr" />
          </div>
          <div class="col-md-2 col-12 mt-2  text-right">
            <small>شماره چک</small>
            <input type="number" name="name" value="" id="ShomareChek" style="direction: ltr" autocomplete="off"
              class="form-control" v-model="ShomareChek" />
          </div>
          <div class="col-md-2 col-12 mt-2 text-right">
            <small>انتخاب حساب</small>
            <select v-if="IsLoad" name="cmbTaahodat" id="cmbTaahodat" class="form-control Pointer" v-model="Resultcmb">
              <option v-if="this.IsLoad == false" value="-2">
                || در حال بارگذاری ، منتظر بمانید ... ||
              </option>
              <option selected value="-1">-- انتخاب حساب --</option>
              <option v-for="item in this.ListModel" :key="item.id" :value="item.id">
                <span>{{ item.vcodeDesNo }}</span>
                <span>{{ item.nameFamily }} </span>
              </option>
            </select>
          </div>
          <div class="col-md-2 col-12 mt-2 text-right">
            <small>انتخاب وضعیت چک</small>
            <select v-if="IsLoad" name="cmbGrp8" id="cmbGrp8" class="form-control Pointer" v-model="ResultcmbGrp8">
              <option v-if="this.IsLoad == false" value="-2">
                || در حال بارگذاری ، منتظر بمانید ... ||
              </option>
              <option selected value="-1">-- انتخاب وضعیت --</option>
              <option v-for="item in this.ListModelcmb" :key="item.id" :value="item.id">
                <span>{{ item.name }}</span>
              </option>
            </select>
          </div>
          <div class="col-md-2 col-12 mt-3">
            <input type="button" name="" value="جستجو" class="btn btn-success mt-2 w-100"
              @click="GetCheque(); $ResetTimer();" />
          </div>
          <div class="col-md-2 col-12 mt-3">
            <export-excel :data="exceltable">
              <!-- <button class="btn btn-outline-success"> -->
              <i class="fas fa-file-excel btn btn-outline-success Pointer d-none" id="DownloadExcel">
                دانلود فایل اکسل
              </i>
              <!-- </button> -->
            </export-excel>
          </div>
        </div>

      </div>
    </div>
    <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config" :classes="classes" :actions="actions"
      @on-download="Download">
      <template slot="sort-asc-icon">
        <i class="fa fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fa fa-sort"></i>
      </template>
      <template slot="empty-results">
        <p class="text-right">اطلاعاتی یافت نشد</p>
      </template>
    </vue-bootstrap4-table>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import Panel from "../Tools/NetPa/Panel.vue";
import loading from "../Tools/NetPa/Loading.vue";
export default {
  data() {
    return {
      DataAxios_cmbTaahodat: { ArryfildValue: "", Method: "Post", Action: "ListTaahodat", Token: this.$session.get("TokenNetPa"), },
      DataAxios_SahebHesab: { ArryfildValue: "", Method: "Post", Action: "ListTaahodat/TaahodatSahebHesab", Token: this.$session.get("TokenNetPa"), },
      DataAxiosRow: { ArryfildValue: "", Method: "Post", Action: "ChkSareHesabNew", Token: this.$session.get("TokenNetPa"), },
      exceltable: [],
      TarikhTa: '',
      TarikhAz: '',
      ListModel: null,
      ListModelcmb: null,
      ListModelSahebHesab: null,
      Resultcmb: null,
      ResultcmbGrp8: null,
      IsLoad: false,
      ShomareChek: '',
      rows: [],
      columns: [{
        label: "ChkId",
        name: "ChkId",
        visibility: false,
      },

      {
        label: "شماره چک",
        name: "SerialChk",
      },
      {
        label: "تاریخ دریافت",
        name: "TarixDaryaft",
      },
      {
        label: "تاریخ چک",
        name: "TarixChk",
      },
      {
        label: "مبلغ چک",
        name: "MablaghChk",
      },
      {
        label: "شماره حساب چک",
        name: "ShHesabChk",
      },
      {
        label: "نام بانک",
        name: "BankName",
      },
      {
        label: "شعبه",
        name: "ShobeChk",
      },
      {
        label: "وضعیت چک",
        name: "Name",
      },
      {
        label: "صاحب چک",
        name: "SahebCheck",
      }
        ,
      {
        label: "حساب/تسهیلات",
        name: "VCode",
      },

      ],
      actions: [{
        btn_text: "<i style='font-size:15px' class='fas fa-file-excel '>",
        event_name: "on-download",
        class: "btn  mx-2 btn-outline-success rounded btnEXL ",
        event_payload: { msg: "my custom msg", },
      }],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      loadingRender: false,

    }
  },
  mounted() {
    this.loadingRender = true;
    this.ListModel = []
    const formData = new FormData();
    formData.append("wwwtblAzaId", this.$session.get("UserInfoNetPa").wwwtblAzaId);
    formData.append("wwwtblSarfaslTypeId", 1);
    this.DataAxios_cmbTaahodat.ArryfildValue = formData;
    this.$PostFormData(this.DataAxios_cmbTaahodat)
      .then((data) => {
      console.log("😂 ~ data:", data)

        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          this.ListModel.push(element);
        }

        this.GetTaahodat()
      })


  },

  components: {
    VueBootstrap4Table,
    Panel,
    loading
  },
  methods: {

    GetTaahodat() {
      this.ResultcmbGrp8 = "-1"
      this.loadingRender = true;
      let info;
      const formData = new FormData();
      formData.append("wwwtblAzaId", this.$session.get("UserInfoNetPa").wwwtblAzaId);
      formData.append("wwwtblSarfaslTypeId", 2);
      this.DataAxios_cmbTaahodat.ArryfildValue = formData;
      this.$PostFormData(this.DataAxios_cmbTaahodat)
        .then((data) => {
          this.IsLoad = true;
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            this.ListModel.push(element);
          }
          this.Resultcmb = this.ListModel[0].id
        })
        .finally(() => {
          const formData = new FormData();
          formData.append("wwwtblAzaId", this.$session.get("UserInfoNetPa").wwwtblAzaId);
          formData.append("wwwtblSarfaslTypeId", 2);
          this.DataAxios_SahebHesab.ArryfildValue = formData;
          this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
            if (data.length > 0) {
              this.IsLoad = true;
              this.ListModelSahebHesab = data;
              for (let index = 0; index < this.ListModelSahebHesab.length; index++) {
                info = this.ListModelSahebHesab[index];
                this.ListModel.push(info);
              }
            }
          });
        }).finally(() => {
          this.loadingRender = false;
          var dataAxsiosCmb = { ArryfildValue: "", Method: "post", Action: "VaziatCombo", Token: this.$session.get("TokenNetPa") }
          const formData = new FormData();
          formData.append('num', 8);
          dataAxsiosCmb.ArryfildValue = formData;
          this.$PostFormData(dataAxsiosCmb).then((datacmb) => {
            this.loadingRender = false;
            if (datacmb.length > 0) {
              this.ListModelcmb = datacmb;
              // this.ResultcmbGrp8 = datacmb[0].id                
            }
          })
        });
    },

    GetCheque() {
      this.loadingRender = true;
      //if(this.ResultcmbGrp8>0){
      let info;
      let list = [];
      const formData = new FormData();
      formData.append('wwwtblAzaId', this.$session.get("UserInfoNetPa").wwwtblAzaId);
      formData.append('wwwtblShobeId', this.$session.get("UserInfoNetPa").wwwtblShobeId);
      formData.append('AzTarix', this.TarikhAz == null ? "" : this.TarikhAz);
      formData.append('TaTarix', this.TarikhTa == null ? "" : this.TarikhTa);
      formData.append('tblComboIdVaziyatChk8', this.ResultcmbGrp8 == "-1" ? null : this.ResultcmbGrp8);
      formData.append('wwwtblTaahodatId', this.Resultcmb);
      formData.append('SerialChk', this.ShomareChek);
      this.DataAxiosRow.ArryfildValue = formData;
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        console.log("😂 ~ data:", data)
        if (typeof (data) == "string") {
          data = JSON.parse(data)
        }
        if (data.length > 0) {
          if (data[0].ChkId > 0) {
            if (data.length > 10) {
              this.config.pagination = true;
            } else {
              this.config.pagination = false;
            }
            for (let index = 0; index < data.length; index++) {
              info = data[index];
              list.push(info);
            }
            
            this.loadingRender = false;
            this.rows = this.$FormatMablaghGrid(list);
            this.exelReport(this.rows);
            this.$store.state.renderComponent = false;
            this.$nextTick(() => {
              this.$store.state.renderComponent = true;
            });
          }
          else {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "عدم وجود اطلاعات",
              "اطلاعاتی یافت نشد ، فیلتر جستجوی خود را تغییر دهید",
              "info",
              2000
            );
            this.config.pagination = false;
            this.rows = [];
          }
        } else {
          this.loadingRender = false;
          this.$mySweetDefaultTost(
            "عدم وجود اطلاعات",
            "اطلاعاتی یافت نشد ، فیلتر جستجوی خود را تغییر دهید",
            "info",
            2000
          );
          this.config.pagination = false;
          this.rows = [];
        }
      });
      // }else{
      //   this.loadingRender=false;
      //   this.$mySweetDefaultTost(
      //         "",
      //         "برای جستجوی چک انتخاب وضعیت چک اجباری میباشد",
      //         "info",
      //         4000
      //       );
      //       this.config.pagination = false;
      //       this.rows = [];
      // }
    },
    Download() {
      document.getElementById("DownloadExcel").click();
    },
    exelReport(rows) {
      this.exceltable = [];
      rows.forEach((element) => {
        var excelrow = {
          "شماره چک": element.SerialChk,
          "تاریخ دریافت": element.TarixDaryaft,
          "مبلغ چک": element.MablaghChk,
          "شماره حساب چک": element.ShHesabChk,
          "نام بانک": element.BankName,
          "شعبه": element.ShobeChk,
          "وضعیت چک": element.Name,
          "صاحب چک": element.SahebCheck,
          "حساب/تسهیلات": element.VCode
        };

        this.exceltable.push(excelrow);
      });
      // console.log( this.exceltable);
    },
  }
}
</script>
<style scoped></style>